import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function InquiryProjectIfbList(props) {
  const Config = {
    purchase: {
      apiPath: '/projectBidding/Order/getPageList',
      enumMainKey: '',
      companyNameKey: 'companyName',
      countApi: '/projectBidding/Order/getCount',
      detailLink: '/mp/purchase/inquiry/project/ifb/detail',
      searchBarPlaceholder: '项目编号、名称查询',
      orderProperty: 'createTime',
      tabs: ['全部', '报价中', '评标中'],
      arrEnumField: [
        {
          mainKey: 'B02_Project_Bidding_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Project_Quote_Status',
          subKey: 'quoteStatus',
          value: 'quoteStatusName'
        }
      ],
      countTransform: (data, self) => {
        //2: 比价中，3：评标中
        let { 2: a, 3: b } = data;
        setCount([undefined, a, b]);
      },
      tabConfig: [
        undefined, //全部
        2, // 比价中
        3 //评标中
      ]
    },
    sale: {
      apiPath: '/customerProjectBiddingOrder/getPageList',
      enumMainKey: '',
      companyNameKey: 'innerCustomerName',
      countApi: '/customerProjectBiddingOrder/count',
      detailLink: '/mp/sale/inquiry/project/ifb/detail',
      searchBarPlaceholder: '项目编号、名称查询',
      orderProperty: 'createTime',
      tabs: ['全部', '报价中', '评标中', '逾期未报价'],
      arrEnumField: [
        {
          mainKey: 'B02_Project_Bidding_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Project_Quote_Status',
          subKey: 'quoteStatus',
          value: 'quoteStatusName'
        }
      ],
      countTransform: (data, self) => {
        //2: 比价中，3：评标中 undefined：逾期未报价
        let { 2: a, 3: b } = data;
        setCount([undefined, a, b, undefined]);
      },
      tabConfig: [
        undefined, //全部
        2, // 比价中
        3, //评标中
        undefined //逾期未报价
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    decimalPlace,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setListField,
    setTotalField,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  self.beforeSearch = async function () {
    self.searchQueries = {
      status: config.tabConfig[currentTab]
    };
    if (currentTab === 1) {
      self.searchQueries.isOverdue = 0;
    }
    if (currentTab === 3) {
      self.searchQueries.isOverdue = 1;
    }
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.pbXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.pbXkNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass(
                                'projectIfb',
                                item.status
                              )
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        <li>
                          <label>项目编号</label>
                          <div>{item.projectBidCode}</div>
                        </li>
                        <li>
                          <label>项目名称</label>
                          <div>{item.projectBidName}</div>
                        </li>
                        <li>
                          <label>招标类别</label>
                          <div>{item.bidCategoryName}</div>
                        </li>
                        <li>
                          <label>发布时间</label>
                          <div>
                            {formatDate(item.publishTime, 'YYYY-MM-DD')}
                          </div>
                        </li>
                        <li>
                          <label>截止时间</label>
                          <div>{formatDate(item.bidEndDate, 'YYYY-MM-DD')}</div>
                        </li>
                        <li>
                          <label>发起人</label>
                          <div>{item.publishName}</div>
                        </li>
                        {!self.isPurchase && (
                          <li>
                            <label>报价状态</label>
                            <div>
                              <span
                                className={
                                  'u-sign ' +
                                  CommonFns.getStatusClass(
                                    'projectIfbQuos',
                                    item.quoteStatus
                                  )
                                }
                              >
                                {item.quoteStatusName}
                              </span>
                            </div>
                          </li>
                        )}
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

InquiryProjectIfbList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(InquiryProjectIfbList);
